import * as React from "react";
const SvgEllipseBottom = (props) => /* @__PURE__ */ React.createElement("svg", { width: 213, height: 47, viewBox: "0 0 213 47", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("ellipse", { opacity: 0.03, cx: 45.6143, cy: 113, rx: 166.614, ry: 113, fill: "currentColor" }));
export default SvgEllipseBottom;
